import { useEffect } from 'react';
import { useHistory } from 'react-router';

export default function ResultRedirect(props: { itemLink: string }) {
  let history = useHistory();

  useEffect(() => {
    if (
      props.itemLink.startsWith('http://') ||
      props.itemLink.startsWith('https://')
    )
      history.push('/extern', props.itemLink);
    else {
      history.push(props.itemLink);
    }
  });

  return <div></div>;
}
